module.exports = __webpack_public_path__ + "images/top.96e3444b58233d73a08aa3b247332ab8.png";